import "./FileItem.css";
import IconsEnum from "../../../../classes/enums/IconsEnum";
import { MODALITY_LABELS } from "../../../../classes/enums/MedicalImagesEnum";
import IconButton from "../../../../components/iconButton/IconButton";
import { useKeyboardActivation } from "../../../../hooks/useKeyboardActivation";
import { formatCreationDate, formatDateDDMMYYYY } from "../../../../classes/utils/DateUtils";
import useTranslation from "../../../../hooks/i18n/useTranslation";

const FileItem = ({ group, onRemove, isImporting }) => {
  const { t } = useTranslation();
  const files = group.files || [];
  const firstFile = files[0] || {};
  const metaData = {
    name: firstFile.name || "",
    numberOfInstances: files.length || 0,
    seriesDescription: firstFile.seriesDescription || "—",
    modality: MODALITY_LABELS[firstFile.modality] || firstFile.modality || "",
    creationDate: firstFile.creationDate
    ? formatDateDDMMYYYY(new Date(
        firstFile.creationDate.slice(0, 4),          
        Number(firstFile.creationDate.slice(4, 6)) - 1, 
        firstFile.creationDate.slice(6, 8)          
      ))
    : ""

  };

  const displayName = `${metaData.name} [${metaData.numberOfInstances}]`;
  const restMeta = Object.entries(metaData).slice(2);

  return (
    <div
      role="button"
      tabIndex={0}
      onKeyDown={useKeyboardActivation(onRemove)}
      className="file-item"
      aria-label={`File: ${metaData.name} [${metaData.numberOfInstances}] ${restMeta.map(([key, value]) => `${key}: ${value}`).join(", ")}`}
    >
      <div className="file-item-name" title={displayName}>
        {displayName || "—"}
      </div>

        {restMeta.map(([key, value]) => (
          <div key={key} className="file-item-meta-row">
            <span className="file-item-meta-value">{value || "—"}</span>
          </div>
        ))}


      <div className="delete-file-button-container">
        {!isImporting && (
          <IconButton
            icon={IconsEnum.DELETE}
            onClick={onRemove}
            noBgColor={true}
            aria-label={`Delete file ${metaData.name}`}
            title={t("438")}
          />
        )}
      </div>
    </div>
  );
};

export default FileItem;
